import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "modal",
    "interviewerEmail",
    "interviewerName",
    "submitBtn",
  ];

  declare interviewerEmailTarget: HTMLInputElement;
  declare interviewerNameTarget: HTMLInputElement;
  declare modalTarget: HTMLElement;
  declare submitBtnTarget: HTMLButtonElement;

  jobOpeningCandidateId: string | null = null;
  jobOpeningId: string | null = null;

  openModal(event: Event): void {
    const button = event.currentTarget as HTMLElement;
    this.jobOpeningCandidateId = button.dataset.jobOpeningCandidateId ?? null;
    this.jobOpeningId = button.dataset.jobOpeningId ?? null;

    this.modalTarget.classList.remove("hidden");
    this.interviewerEmailTarget.value = "";
    this.interviewerNameTarget.value = "";
    this.submitBtnTarget.disabled = true;
  }

  closeModal(): void {
    this.modalTarget.classList.add("hidden");
  }

  handleSendInvitationOnClick(event: Event): void {
    event.preventDefault();

    const form = document.getElementById(
      "send_interview_form"
    ) as HTMLFormElement;

    this.appendInputToForm(form, "email", this.interviewerEmailTarget.value);
    this.appendInputToForm(
      form,
      "interviewer_name",
      this.interviewerNameTarget.value
    );

    const formatInput = document.querySelector<HTMLInputElement>(
      "input[name='format']:checked"
    );
    if (formatInput) {
      this.appendInputToForm(form, "format", formatInput.value);
    }

    const withMeetLinkInput = document.getElementById(
      "with_meet_link"
    ) as HTMLInputElement;
    if (withMeetLinkInput) {
      this.appendInputToForm(
        form,
        "with_meet_link",
        withMeetLinkInput.checked ? "true" : "false"
      );
    }

    const sendSettingUpEmailInput = document.getElementById(
      "send_setting_up_email"
    ) as HTMLInputElement;
    if (sendSettingUpEmailInput) {
      this.appendInputToForm(
        form,
        "send_setting_up_email",
        sendSettingUpEmailInput.checked ? "true" : "false"
      );
    }

    if (this.jobOpeningCandidateId) {
      this.appendInputToForm(
        form,
        "job_opening_candidate_ids",
        this.jobOpeningCandidateId
      );
    }

    form.action = `/admin/job_openings/${this.jobOpeningId}/candidates/interviews`;

    form.submit();
  }

  appendInputToForm(form: HTMLFormElement, name: string, value: string): void {
    const hiddenContentInput = document.createElement("input");
    hiddenContentInput.type = "hidden";
    hiddenContentInput.name = name;
    hiddenContentInput.value = value;
    form.appendChild(hiddenContentInput);
  }

  checkContentChanged(): void {
    const content = this.interviewerEmailTarget.value.trim();
    const nameContent = this.interviewerNameTarget.value.trim();
    const isValid = this.isValidEmail(content);

    this.submitBtnTarget.disabled =
      content.length === 0 || !isValid || nameContent.length === 0;

    const errorEl = document.getElementById("email_error");
    if (errorEl) {
      errorEl.textContent =
        isValid || content === "" ? "" : "Invalid email address";
    }
  }

  isValidEmail(email: string): boolean {
    // Basic email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
}
